import { LOADING } from "../../../constants/constant";
import {
  SUBMIT_PRE_SELECTED_CARRIER,
  SUBMIT_PRE_SELECTED_CARRIER_FAILED,
  SUBMIT_PRE_SELECTED_CARRIER_SUCCESS,
} from "../../actions/ActionType";

const initialState = {
  status: "INIT",
  isLoading: true,
};

export default function submitPreselectedCarriersListReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case SUBMIT_PRE_SELECTED_CARRIER:
      let reqstState = Object.assign({}, state);
      reqstState.isLoading = true;
      reqstState.status = LOADING;
      return reqstState;

    case SUBMIT_PRE_SELECTED_CARRIER_SUCCESS:
      let userRes = Object.assign({}, state);
      userRes.status = action.data.status_message;
      userRes.isLoading = false;
      userRes.statusCode = action.data.status_code;

      if (userRes.statusCode === 10) {
        userRes.error = false;
        userRes.isRequestSubmitted = true;
      } else {
        userRes.error = true;
        userRes.errorMessage = action.data.message;
      }
      return userRes;

    case SUBMIT_PRE_SELECTED_CARRIER_FAILED:
      return Object.assign({}, state, action.error);

    default:
      return state;
  }
}
